import { useFormikContext } from 'formik';
import React, { useCallback } from 'react';
import FieldFormControl from '../FieldFormControl';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { InsightSelectFormikWrapper } from '../InsightSelectFormikWrapper';
import InsightFieldSelect from '@/components/selects/InsightFieldSelect';

const FIELD_TYPE = 'AuthorisedRep';

const AuthRepSelect = ({ field, disabled }) => {
	const { values, setFieldValue, getFieldMeta, getFieldProps, getFieldHelpers } =
		useFormikContext();

	const { onBlur: onFieldBlur } = getFieldProps(field.name);
	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const authRepFields = Object.entries(values).filter(
		([key]) =>
			key.includes(FIELD_TYPE) &&
			key.endsWith('Id') &&
			!key.includes('-') &&
			key !== field.name,
	);

	const { getFeatureFlags } = useFeatureFlagContext();
	const clientConfigInsightSelection = Boolean(
		getFeatureFlags('clientConfigInsightSelection')?.active,
	);

	const isOptionDisabled = useCallback(
		(option) => {
			const otherFields = authRepFields.map(([k, v]) => v);
			return otherFields.some(
				(value) => value && (value === option?.Id || value?.Id === option?.Id),
			);
		},
		[authRepFields, field.name],
	);

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	const handleChange = (newValue) => {
		setFieldValue(field.name, newValue?.insightId);
	};

	if (clientConfigInsightSelection) {
		return (
			<InsightSelectFormikWrapper
				{...{
					field,
					disabled,
					isOptionDisabled,
				}}
			/>
		);
	}

	return (
		<FieldFormControl {...{ disabled, field }}>
			<InsightFieldSelect
				value={values[field.name]}
				fieldType={FIELD_TYPE}
				onChange={handleChange}
				isOptionDisabled={(option) => {
					const otherFields = authRepFields.map(([k, v]) => v);
					// Authorised rep ID must be unique
					if (otherFields.some((f) => values[f] === option.insightId)) {
						return true;
					}
					return false;
				}}
				{...{ onBlur, error, disabled }}
			/>
		</FieldFormControl>
	);
};
export default AuthRepSelect;
